const de = {
  // Navbar
  nav: {
    features: 'Funktionen',
    about: 'Über uns',
    faq: 'FAQ',
    support: 'Support',
    signIn: 'Anmelden',
    getStarted: 'Kostenlos starten',
  },

  // Footer
  footer: {
    tagline: 'Der professionelle Dokumentenscanner, der deine Dateien organisiert, sicher und immer griffbereit hält.',
    product: 'Produkt',
    company: 'Unternehmen',
    legal: 'Rechtliches',
    links: {
      features: 'Funktionen',
      faq: 'FAQ',
      support: 'Support',
      about: 'Über uns',
      contact: 'Kontakt',
      privacy: 'Datenschutzerklärung',
      terms: 'Nutzungsbedingungen',
      impressum: 'Impressum',
      cookiePolicy: 'Cookie-Richtlinie',
      dataDeletion: 'Datenlöschung',
    },
    copyright: '© {year} Docudi. Alle Rechte vorbehalten.',
    complianceNote: 'Docudi ist der DSGVO verpflichtet. Deine Daten gehören dir.',
  },

  // Hero
  hero: {
    badge: 'Dokumentenscanner-App',
    headline1: 'Deine Dokumente,',
    headline2: 'perfekt organisiert.',
    sub: 'Scanne, organisiere und greife von überall auf deine Dokumente zu. Docudi verwandelt Papierchaos in ein sauberes, durchsuchbares digitales Archiv — in Sekunden.',
    ctaPrimary: 'Kostenlos laden',
    ctaSecondary: 'So funktioniert\'s',
    socialProof: 'Weltweit von Nutzern vertraut',
    badge1: 'Gescannt in 2 Sek.',
    badge2: 'Ende-zu-Ende verschlüsselt',
  },

  // Trust bar
  trust: {
    encryption: 'Ende-zu-Ende verschlüsselt',
    gdpr: 'DSGVO-konform',
    uptime: '99,9 % Verfügbarkeit',
    zeroKnowledge: 'Zero-Knowledge-Architektur',
    sync: 'Geräteübergreifende Synchronisierung',
    rating: '5-Sterne-Bewertung',
  },

  // Problem / Solution
  problemSolution: {
    badge: 'Problem & Lösung',
    headline: 'Schluss mit dem Papierchaos. Arbeite smarter.',
    sub: 'Papierdokumente kosten dich Zeit. Docudi gibt dir die Kontrolle zurück.',
    before: 'Ohne Docudi',
    after: 'Mit Docudi',
    problems: [
      'Zeitverschwendung beim Suchen in physischen Ordnern',
      'Wichtige Dokumente gehen verloren oder werden beschädigt',
      'Kein Zugriff auf Dateien außerhalb des Büros',
      'Dokumente teilen ist langsam und unsicher',
    ],
    solutions: [
      'Jedes Dokument in Sekunden per Volltextsuche finden',
      'Alle Dokumente sicher gespeichert und verschlüsselt',
      'Zugriff auf dein gesamtes Archiv von jedem Gerät',
      'Sicher teilen mit einem Tippen',
    ],
  },

  // Features
  features: {
    badge: 'Funktionen',
    headline: 'Alles, was du für papierloses Arbeiten brauchst',
    headlineAccent: 'papierloses',
    sub: 'Leistungsstarke Funktionen für müheloses Dokumentenmanagement.',
    viewAll: 'Alle Funktionen ansehen',
    items: {
      scan: { title: 'Intelligentes Scannen', desc: 'Automatische Kantenerkennung, Perspektivkorrektur und Bildverbesserung in Echtzeit.' },
      ocr: { title: 'OCR-Texterkennung', desc: 'Text aus jedem Dokument extrahieren und durchsuchen. Alles sofort finden.' },
      org: { title: 'Smarte Organisation', desc: 'Automatische Kategorisierung, Ordner und Smart-Tags halten alles ordentlich.' },
      search: { title: 'Volltextsuche', desc: 'In Dokumenten suchen — nicht nur nach Dateinamen.' },
      export: { title: 'PDF & Export', desc: 'Als PDF oder JPEG exportieren oder direkt an andere Apps senden.' },
      sync: { title: 'Cloud-Synchronisierung', desc: 'Alle Dokumente auf allen Geräten synchronisiert — jederzeit.' },
      security: { title: 'Bank-Sicherheit', desc: 'AES-256-Verschlüsselung im Ruhezustand und bei der Übertragung.' },
      offline: { title: 'Offline verfügbar', desc: 'Dokumente scannen und aufrufen — auch ohne Internet.' },
    },
  },

  // How It Works
  howItWorks: {
    badge: 'So funktioniert\'s',
    headline: 'Von Papier zu digital\nin vier einfachen Schritten',
    sub: 'Keine Lernkurve. Keine komplizierte Einrichtung. Einfach scannen, organisieren und zugreifen.',
    steps: [
      {
        step: '01',
        title: 'Herunterladen & installieren',
        description: 'Hol dir Docudi aus dem App Store oder Google Play. Richte dein Konto in unter 60 Sekunden ein — keine komplizierte Konfiguration nötig.',
        detail: 'Verfügbar für iOS und Android.',
      },
      {
        step: '02',
        title: 'Erstes Dokument scannen',
        description: 'Richte die Kamera auf ein Dokument. Die intelligente Kantenerkennung von Docudi rahmt, schneidet zu und verbessert das Bild automatisch.',
        detail: 'Funktioniert mit Rechnungen, Verträgen, Ausweisen, Belegen, Büchern, Whiteboards und mehr.',
      },
      {
        step: '03',
        title: 'Mit Smart-Tags organisieren',
        description: 'Füge eigene Labels hinzu, erstelle Ordner und nutze Smart-Collections, um alles perfekt zu organisieren.',
        detail: 'Nutze die OCR-gestützte Suche, um jedes Dokument nach Inhalt zu finden — nicht nur nach Namen.',
      },
      {
        step: '04',
        title: 'Überall sicher zugreifen',
        description: 'Dein verschlüsselter Dokumententresor synchronisiert sich auf allen Geräten. Greife von deinem Smartphone oder Tablet zu — wann immer du es brauchst.',
        detail: 'Dokumente teilen oder als PDF exportieren mit einem Tippen.',
      },
    ],
  },

  // Security
  security: {
    badge: 'Datenschutz & Sicherheit',
    headline: 'Deine Dokumente verdienen den',
    headlineAccent: 'höchsten Schutz',
    sub: 'Datenschutz ist bei Docudi kein nachträglicher Gedanke — er ist ein grundlegendes Designprinzip.',
    items: [
      {
        title: 'Ende-zu-Ende-Verschlüsselung',
        description: 'Alle Dokumente werden mit AES-256 verschlüsselt, bevor sie übertragen oder gespeichert werden. Deine Daten sind in jeder Phase geschützt.',
      },
      {
        title: 'DSGVO-konformes Design',
        description: 'Docudi ist nach Privacy-by-Design-Prinzipien entwickelt. Deine Daten werden gemäß den geltenden Datenschutzbestimmungen verarbeitet.',
      },
      {
        title: 'Betroffenenrechte',
        description: 'Exportiere oder lösche alle deine Daten jederzeit. Wir respektieren Betroffenenrechte gemäß geltendem Recht.',
      },
    ],
  },

  // Cross-platform
  crossPlatform: {
    badge: 'Plattformübergreifend',
    headline: 'Deine Dokumente, überall',
    sub: 'Eine App, alle Geräte. Docudi funktioniert nahtlos auf iOS und Android.',
    benefits: [
      'Sofortige Synchronisierung auf allen Geräten',
      'Konsistente Erfahrung auf jeder Plattform',
      'Offline-Zugriff auf deine Dokumente',
      'Automatische Backups',
    ],
    platforms: {
      ios: 'Verfügbar für iOS',
      android: 'Verfügbar für Android',
    },
    syncLabel: 'Synchronisiere…',
  },

  // FAQ Preview
  faqPreview: {
    badge: 'FAQ',
    headline: 'Häufig gestellte Fragen',
    sub: 'Nicht gefunden, was du suchst? Schau in die vollständige FAQ oder kontaktiere uns.',
    viewAll: 'Alle FAQs ansehen',
    contact: 'Support kontaktieren',
  },

  // Final CTA
  finalCta: {
    badge: 'Jetzt starten',
    headline: 'Bereit für papierloses Arbeiten?',
    sub: 'Lade Docudi kostenlos herunter und beginne noch heute mit dem Scannen.',
    ctaPrimary: 'Kostenlos laden',
    ctaSecondary: 'Funktionen entdecken',
    trust1: 'Kostenlos herunterladen',
    trust2: 'Keine Kreditkarte erforderlich',
    trust3: 'Jederzeit kündbar',
  },

  // FAQs
  faqs: [
    {
      category: 'Produkt',
      question: 'Welche Dokumenttypen kann ich mit Docudi scannen?',
      answer: 'Docudi funktioniert mit nahezu jedem Dokument — Rechnungen, Verträge, Quittungen, Ausweise, Visitenkarten, handgeschriebene Notizen, Bücher und mehr. Die intelligente Kantenerkennung verarbeitet alles von Standard-A4-Seiten bis zu unregelmäßigen Formen.',
    },
    {
      category: 'Produkt',
      question: 'Funktioniert Docudi auch offline?',
      answer: 'Ja. Zuletzt geöffnete Dokumente sind offline auf deinem Gerät verfügbar. Neue Scans werden in der Warteschlange gespeichert und automatisch synchronisiert, sobald du wieder online bist.',
    },
    {
      category: 'Produkt',
      question: 'Wie gut ist die OCR-Texterkennung?',
      answer: 'Unsere OCR-Engine unterstützt über 50 Sprachen und erkennt sowohl gedruckten als auch handgeschriebenen Text. Unter normalen Bedingungen übersteigt die Genauigkeit bei gedruckten Dokumenten 98 %.',
    },
    {
      category: 'Datenschutz & Sicherheit',
      question: 'Sind meine Daten wirklich Ende-zu-Ende verschlüsselt?',
      answer: 'Ja. Dokumente werden auf deinem Gerät mit AES-256 verschlüsselt, bevor sie übertragen oder gespeichert werden. Unsere Infrastruktur ist so konzipiert, dass Docudi-Mitarbeiter keinen Zugriff auf deine Dokumentinhalte haben.',
    },
    {
      category: 'Datenschutz & Sicherheit',
      question: 'Wo werden meine Daten gespeichert?',
      answer: 'Deine Daten werden auf Servern gespeichert, die den geltenden Datenschutzvorschriften entsprechen. Vollständige Details findest du in unserer Datenschutzerklärung.',
    },
    {
      category: 'Datenschutz & Sicherheit',
      question: 'Kann ich alle meine Daten dauerhaft löschen?',
      answer: 'Absolut. Du kannst jederzeit die vollständige Löschung deines Kontos und aller zugehörigen Daten beantragen. Weitere Details findest du auf unserer Datenlöschungsseite.',
    },
    {
      category: 'Abrechnung',
      question: 'Kann ich mein Abonnement jederzeit kündigen?',
      answer: 'Ja. Du kannst jederzeit in deinen Kontoeinstellungen kündigen. Dein Tarif bleibt bis zum Ende des Abrechnungszeitraums aktiv. Es gibt keine Kündigungsgebühren.',
    },
    {
      category: 'Abrechnung',
      question: 'Gibt es eine kostenlose Testphase?',
      answer: 'Ja. Die App ist kostenlos zum Herunterladen und Nutzen. Premium-Funktionen können ein Abonnement erfordern. Für den Start ist keine Kreditkarte erforderlich.',
    },
    {
      category: 'Technisch',
      question: 'Welche Geräte und Plattformen werden unterstützt?',
      answer: 'Docudi ist als native App für iOS (iPhone & iPad) und Android verfügbar. Alle Versionen synchronisieren sich in Echtzeit.',
    },
    {
      category: 'Technisch',
      question: 'Auf wie vielen Geräten kann ich ein Konto verwenden?',
      answer: 'Du kannst Docudi mit einem einzigen Abonnement auf unbegrenzt vielen Geräten verwenden. Alle Geräte synchronisieren sich automatisch.',
    },
  ],

  // Features page — advanced table
  featuresTable: {
    headline: 'Vollständige Funktionsübersicht',
    sub: 'Alle Funktionen von Docudi, nach Kategorie geordnet.',
    ctaPrimary: 'Kostenlos laden',
    categories: {
      scanning: {
        title: 'Scannen',
        items: [
          'Automatische Kantenerkennung & Zuschnitt',
          'Perspektivkorrektur',
          'Schatten- & Lichtverbesserung',
          'Stapel-Scannen',
          'QR- & Barcode-Erkennung',
          'Visitenkartenscanner',
        ],
      },
      organisation: {
        title: 'Organisation',
        items: [
          'Eigene Ordner & Unterordner',
          'Smart-Tags & Labels',
          'Favoriten & markierte Dokumente',
          'Automatische Datumsextraktion',
          'Duplikaterkennung',
          'Versionsverlauf',
        ],
      },
      search: {
        title: 'Suche',
        items: [
          'Volltextsuche via OCR',
          'Suche innerhalb von PDFs',
          'OCR in 50+ Sprachen',
          'Filter nach Datum, Typ, Größe',
          'Zuletzt geöffnete Dokumente',
          'Gespeicherte Suchfilter',
        ],
      },
      export: {
        title: 'Export & Teilen',
        items: [
          'Mehrseitige PDF-Erstellung',
          'JPEG & PNG Export',
          'Passwortgeschützte PDFs',
          'Direkte E-Mail-Freigabe',
          'Cloud-Speicher-Integration',
          'Direkt aus der App drucken',
        ],
      },
      security: {
        title: 'Sicherheit',
        items: [
          'AES-256-Verschlüsselung',
          'Zwei-Faktor-Authentifizierung',
          'Biometrischer Login',
          'App-Sperr-PIN',
          'Sichere Freigabelinks',
          'Remote-Gerätewipe',
        ],
      },
      productivity: {
        title: 'Produktivität',
        items: [
          'Widgets (iOS & Android)',
          'Siri- & Google-Assistant-Verknüpfungen',
          'Erinnerungen & Ablaufdaten',
          'Dokumentvorlagen',
          'Web-Clipper-Browsererweiterung',
          'Kalenderintegration',
        ],
      },
    },
  },

  // Pages
  pages: {
    features: {
      title: 'Funktionen',
      headline: 'Alles für papierloses Arbeiten',
      sub: 'Leistungsstarkes Scannen, Organisation und Sicherheit — alles in einer App.',
    },
    about: {
      title: 'Über Docudi',
      headline: 'Entwickelt für Menschen, die ihre Zeit schätzen',
      sub: 'Unsere Mission: Dokumentenmanagement einfach, sicher und für alle zugänglich zu machen.',
    },
    contact: {
      title: 'Kontakt',
      headline: 'Melde dich bei uns',
      sub: 'Fragen, Feedback oder Support-Anfragen — wir sind für dich da.',
    },
    faq: {
      title: 'FAQ',
      headline: 'Häufig gestellte Fragen',
      sub: 'Antworten auf die häufigsten Fragen zu Docudi.',
    },
    support: {
      title: 'Support',
      headline: 'Wie können wir helfen?',
      sub: 'Support-Themen durchsuchen, FAQ prüfen oder unser Team kontaktieren.',
    },
  },

  // Cookie banner
  cookie: {
    title: '🍪 Wir verwenden Cookies',
    desc: 'Wir nutzen essentielle Cookies, damit Docudi funktioniert, und optionale Cookies zur Verbesserung deiner Erfahrung.',
    manage: 'Einstellungen verwalten',
    reject: 'Nicht-Essentielle ablehnen',
    acceptAll: 'Alle akzeptieren',
    prefTitle: 'Cookie-Einstellungen',
    back: '← Zurück',
    save: 'Einstellungen speichern',
    essential: { name: 'Essentielle Cookies', desc: 'Für die Kernfunktionalität erforderlich. Kann nicht deaktiviert werden.' },
    functional: { name: 'Funktionale Cookies', desc: 'Speichern deine Einstellungen und personalisieren deine Erfahrung.' },
    analytics: { name: 'Analyse-Cookies', desc: 'Helfen uns zu verstehen, wie Nutzer die App verwenden.' },
    marketing: { name: 'Marketing-Cookies', desc: 'Werden für relevante Werbung verwendet.' },
  },

  // Legal pages
  legalPages: {
    badge: 'Rechtliches',
    lastUpdated: 'Zuletzt aktualisiert:',
    disclaimer: '⚠️ Wichtig: Diese Seite enthält Platzhalterverlage, die vor der Veröffentlichung von einem Rechtsanwalt geprüft und vervollständigt werden müssen. Verlasse dich nicht auf diesen Inhalt als Rechtsberatung oder als vollständiges und gesetzeskonformes Rechtsdokument.',
    privacy: {
      title: 'Datenschutzerklärung',
      metaDesc: 'Erfahre, wie Docudi deine personenbezogenen Daten erhebt, verarbeitet und schützt.',
    },
    terms: {
      title: 'Nutzungsbedingungen',
      metaDesc: 'Lies die Nutzungsbedingungen für die Verwendung von Docudi.',
    },
    cookies: {
      title: 'Cookie-Richtlinie',
      metaDesc: 'Erfahre, wie Docudi Cookies und ähnliche Tracking-Technologien verwendet.',
    },
    dataDeletion: {
      title: 'Datenlöschung',
      metaDesc: 'Erfahre, wie du deine Daten bei Docudi löschen kannst.',
    },
  },

  // 404
  notFound: {
    title: 'Seite nicht gefunden',
    desc: 'Die gesuchte Seite existiert nicht oder wurde verschoben.',
    home: 'Zur Startseite',
    help: 'Hilfe erhalten',
  },
};

export default de;
